/**
 * constant which is used to export the patterns.
 */
export const pattern = {
  emailValidation: '([a-z0-9._%+-]{1,40}[@]{1}[a-z]+[.]{1}[a-z]{2,})',
  passwordPattern: '^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9])(?=.*[a-z]).{8,}$',
  domainPattern: /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  zipCode: '^[a-zA-Z0-9]{4,7}$',
  contactNumber: '^[0-9]{10,12}$',
  namePattern: '^[A-Za-z]+(?:\\s[A-Za-z]+)*$'
}